import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setLocalSearchHistory } from "../../../../helpers/generalHelper";

const MobileSearch = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const onSearchSubmit = (e) => {
    const searchValue = e.target.search?.value || "";
    e.preventDefault();
    history.push("/browse", {
      search: searchValue,
    });

    if (searchValue !== "") setLocalSearchHistory(searchValue);

    history.go();
  };
  return (
    <div className="offcanvas-mobile-search-area">
      <form action="#" id="mobile_header_search_form" onSubmit={onSearchSubmit}>
        <input type="search" name="search" placeholder={t("search")} />
        <button type="submit" form="mobile_header_search_form">
          <i className="fa fa-search" />
        </button>
      </form>
    </div>
  );
};

export default MobileSearch;
